import { useNeedHelpServicePostApiNeedHelpNeedHelp } from "../../../openapi/queries";
import { showErrorToast } from "../../configurator/renderer/tools/helper";
import { ApiErrorResponse } from "../../configurator/renderer/tools/types";
import { emailRegex } from "../../tools/regex";
import { BaseModal } from "../common/BaseModal/BaseModal";
import { LabeledInput } from "../common/LabeledInput/LabeledInput";

import { JSX, useState } from "react";
import { useTranslation } from "react-i18next";

import { ApiError } from "@4pace-cpq/core";
import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";

export const BtnNeedHelp = (): JSX.Element => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [formInquiry, setFormInquiry] = useState<string>("");
  const [formUserName, setFormUserName] = useState<string>("");
  const [formUserEmail, setFormUserEmail] = useState<string>("");
  const [formPhoneNumber, setFormPhoneNumber] = useState<string>("");
  const [formUserCompany, setFormUserCompany] = useState<string>("");
  const [formUserCountry, setFormUserCountry] = useState<string>("");
  const [formUserRegion, setFormUserRegion] = useState<string>("");
  const { mutate: mutateHelpRequest } =
    useNeedHelpServicePostApiNeedHelpNeedHelp();
  const [status, setStatus] = useState<string>("init");

  const handleCloseModal = (): void => {
    setIsModalOpen(false);
  };
  const handleOpenModal = (): void => {
    setIsModalOpen(true);
  };
  const handleSubmit = (): void => {
    setIsLoading(true);
    setStatus("default");
    mutateHelpRequest(
      {
        requestBody: {
          name: formUserName,
          eMail: formUserEmail,
          phoneNumber: formPhoneNumber,
          company: formUserCompany,
          country: formUserCountry,
          region: formUserRegion,
          comment: formInquiry,
        },
      },
      {
        onSuccess: () => {
          setStatus("success");
          setIsLoading(false);
          handleCloseModal();
        },
        onError: (error) => {
          const errorData = error as ApiError;
          const errorBody = errorData.body as ApiErrorResponse;
          setStatus("error");
          console.warn("Error sending help request", error);
          setIsLoading(false);
          showErrorToast(
            t(`WEG:${errorBody.key}`, errorBody.message, {
              params: errorBody.params,
            }),
          );
        },
      },
    );
  };

  const formNotValid =
    !formInquiry || !formUserName || !emailRegex.test(formUserEmail);

  return (
    <>
      <Button
        variant="text"
        onClick={handleOpenModal}
        sx={{ textTransform: "uppercase" }}
      >
        {t("WEG:preselector.page1.linkText")}
      </Button>
      <BaseModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={t("WEG:preselector.page1.linkText")}
        customSx={{
          minWidth: "30em",
          width: "25%",
        }}
        isLoading={isLoading}
      >
        <Box>
          <Grid container columnSpacing={1} rowSpacing={2}>
            <Grid size={12}>
              <LabeledInput
                required
                fullWidth={true}
                label={t("WEG:label.form.userInquiry")}
                multiline
                rows={4}
                value={formInquiry}
                handleChange={(val) => setFormInquiry(val)}
              />
            </Grid>
            <Grid size={6}>
              <LabeledInput
                required
                fullWidth={true}
                label={t("WEG:label.form.name")}
                value={formUserName}
                handleChange={(val) => setFormUserName(val)}
              />
            </Grid>
            <Grid size={6}>
              <LabeledInput
                required
                fullWidth={true}
                label={t("WEG:label.form.email")}
                value={formUserEmail}
                handleChange={(val) => setFormUserEmail(val)}
              />
            </Grid>
            <Grid size={6}>
              <LabeledInput
                fullWidth={true}
                label={t("WEG:label.form.phoneNumber")}
                value={formPhoneNumber}
                handleChange={(val) => setFormPhoneNumber(val)}
              />
            </Grid>
            <Grid size={6}>
              <LabeledInput
                fullWidth={true}
                label={t("WEG:label.form.company")}
                value={formUserCompany}
                handleChange={(val) => setFormUserCompany(val)}
              />
            </Grid>
            <Grid size={6}>
              <LabeledInput
                fullWidth={true}
                label={t("WEG:label.form.country")}
                value={formUserCountry}
                handleChange={(val) => setFormUserCountry(val)}
              />
            </Grid>
            <Grid size={6}>
              <LabeledInput
                fullWidth={true}
                label={t("WEG:label.form.formRegion")}
                value={formUserRegion}
                handleChange={(val) => setFormUserRegion(val)}
              />
            </Grid>
          </Grid>
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button
              variant="contained"
              color={
                status === "success"
                  ? "success"
                  : status === "error"
                    ? "error"
                    : "primary"
              }
              disabled={formNotValid}
              onClick={handleSubmit}
            >
              {t("WEG:button.send")}
            </Button>
          </Box>
        </Box>
      </BaseModal>
    </>
  );
};
